import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { getTenantLicense, type License } from '../../api/licenses';
import { LicenseSummary } from './LicenseSummary';

/** The tenant's license on the platform admin's tenant page. Managing it
 *  (issue, renew, limits, sub-licenses) lives on the Licenses page. */
export function TenantLicenseCard({ tenantId }: { tenantId: string }) {
  const [license, setLicense] = useState<License | null | undefined>(undefined);

  useEffect(() => {
    getTenantLicense(tenantId).then(setLicense, () => setLicense(undefined));
  }, [tenantId]);

  if (license === undefined) return null;
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
        <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 600 }}>
          License
        </Typography>
        <Button size="small" component={RouterLink} to="/admin/licenses">
          {license ? 'Manage' : 'Issue a license'}
        </Button>
      </Stack>
      {license ? (
        <LicenseSummary license={license} />
      ) : (
        <Typography variant="body2" color="text.secondary">
          Unlicensed — nothing is limited until a license is issued.
        </Typography>
      )}
    </Paper>
  );
}
